import BaseRequest from './BaseRequest';

const schema = 'commission';

export default class CommissionRequest extends BaseRequest {
  fetchUsers(params) {
    const url = `${schema}/user/paginate`;
    return this.get(url, params);
  }

  fetchUserByTime(params) {
    const url = `${schema}/user/filter-time`;
    return this.get(url, params);
  }

  fetchUser(params) {
    const url = `${schema}/user`;
    return this.get(url, params);
  }

  fetchByTime(params) {
    const url = `${schema}/filter-time`;
    return this.get(url, params);
  }

  fetchAll(params) {
    const url = `${schema}`;
    return this.get(url, params);
  }

  fetchTotalReferrals() {
    const url = `${schema}/total-referrals`;
    return this.get(url);
  }

  fetchListMapLevel(params) {
    const url = `${schema}/list-commission-map-level`;
    return this.get(url, params);
  }

  fetchListPartners(params) {
    const url = `${schema}/list-partner`;
    return this.get(url, params);
  }
}
